import React, { FunctionComponent } from 'react';
import { TreeItem, TreeView } from '@mui/lab';
import { Fade, Typography } from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

import { ILessonHistory } from '../../../../../../../../../store/V2/LessonHistorySlice';

interface AttendanceHistoryTabProps {
  lessonHistory: ILessonHistory;
}

const AttendanceHistoryTab: FunctionComponent<AttendanceHistoryTabProps> = ({
  lessonHistory,
}) => {
  const attendanceHistoryList = lessonHistory.attendanceHistory || [];

  return (
    <Fade in>
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Typography fontWeight={600} fontSize="16px">
            Attendance
          </Typography>
        </div>
        {attendanceHistoryList.length ? (
          <div>
            <TreeView
              aria-label="file system navigator"
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
            >
              {attendanceHistoryList.map((attendanceHistory, index) => (
                <TreeItem
                  key={index}
                  nodeId={index.toString()}
                  label={`${attendanceHistory.name}     -     ( ${new Date(
                    attendanceHistory.join_time
                  ).toLocaleString('en-US', { timeZoneName: 'short' })} )`}
                  style={{ marginBottom: '20px' }}
                >
                  <TreeItem
                    nodeId={attendanceHistory.id}
                    label={
                      <pre>{JSON.stringify(attendanceHistory, null, 2)}</pre>
                    }
                  />
                </TreeItem>
              ))}
            </TreeView>
          </div>
        ) : (
          <div>
            <Typography fontWeight={500} fontSize="16px">
              No records are available!
            </Typography>
          </div>
        )}
      </div>
    </Fade>
  );
};

export default AttendanceHistoryTab;
